import { render, staticRenderFns } from "./GlossaryPanel.vue?vue&type=template&id=3ab1773f"
import script from "./GlossaryPanel.vue?vue&type=script&lang=js"
export * from "./GlossaryPanel.vue?vue&type=script&lang=js"
import style0 from "./GlossaryPanel.vue?vue&type=style&index=0&id=3ab1773f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports